"use strict";
import {
  schemeCategory10,
  schemeSet1,
  schemeSet2,
  schemeSet3,
  schemePaired,
  schemeTableau10,
  interpolateRainbow
} from "d3-scale-chromatic";
function isNotGreyWhiteBlackRed(hex) {
  const c = hex.replace("#", "");
  if (c.length !== 6) return true;
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const isGrey = Math.abs(r - g) < 10 && Math.abs(g - b) < 10 && Math.abs(r - b) < 10;
  const isWhite = r > 240 && g > 240 && b > 240;
  const isBlack = r < 20 && g < 20 && b < 20;
  const isRed = r > 180 && g < 100 && b < 100;
  return !(isGrey || isWhite || isBlack || isRed);
}
const FLAT_PALETTES = [
  ...schemeCategory10,
  ...schemeSet1,
  ...schemeSet2,
  ...schemePaired,
  ...schemeTableau10,
  ...Array.isArray(schemeSet3[12]) ? schemeSet3[12] : []
].filter(isNotGreyWhiteBlackRed);
const UNIQUE_COLORS = Array.from(new Set(FLAT_PALETTES));
export function generateColors(n) {
  if (n <= UNIQUE_COLORS.length) return UNIQUE_COLORS.slice(0, n);
  return [
    ...UNIQUE_COLORS,
    ...Array.from(
      { length: n - UNIQUE_COLORS.length },
      (_, i) => interpolateRainbow(i / (n - UNIQUE_COLORS.length) * 0.85)
    )
  ];
}
export const COLORS = generateColors(30);
